import queryString from 'query-string';
import { showInfo } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_MUSIC_DATA = 'SET_MUSIC_DATA';
export const setMusicData = (musicData) => ({
    type: SET_MUSIC_DATA,
    data: musicData,
});

export const ADD_MUSIC_DATA = 'ADD_MUSIC_DATA';
const addMusicData = (musicData) => ({
    type: ADD_MUSIC_DATA,
    data: musicData,
});

export const SET_FILTERED_MUSIC_DATA = 'SET_FILTERED_MUSIC_DATA';
const setFilteredMusicData = (filteredMusicData) => ({
    type: SET_FILTERED_MUSIC_DATA,
    data: filteredMusicData,
});

export const ADD_FILTERED_MUSIC_DATA = 'ADD_FILTERED_MUSIC_DATA';
const addFilteredMusicData = (filteredMusicData) => ({
    type: ADD_FILTERED_MUSIC_DATA,
    data: filteredMusicData,
});

export const SET_IS_LOADING_MUSICS_PAGE = 'SET_IS_LOADING_MUSICS_PAGE';
const setIsLoading = (isLoading) => ({
    type: SET_IS_LOADING_MUSICS_PAGE,
    isLoading,
});

export const SET_NO_MORE_MUSICS = 'SET_NO_MORE_MUSICS';
const setNoMoreMusics = (data) => ({
    type: SET_NO_MORE_MUSICS,
    data,
});

export const SET_NO_MORE_FILTERED_MUSICS = 'SET_NO_MORE_FILTERED_MUSICS';
const setNoMoreFilteredMusics = (data) => ({
    type: SET_NO_MORE_FILTERED_MUSICS,
    data,
});

export const SET_LAST_FILTER_QUERY = 'SET_LAST_FILTER_QUERY';
const setLastFilterQuery = (data) => ({
    type: SET_LAST_FILTER_QUERY,
    data,
});

export const getMusicDataIfNeeded = (num, init) => (dispatch, getState) => {
    const musicsPageData = getState().musics.musicsPage.musicsPageData;

    if (musicsPageData.length < num + init) {
        const query = `api/v1/getMusicData/${num}/${init}`;

        dispatch(setIsLoading(true));

        return Api.progressGet(dispatch, query)
            .then((json) => {
                dispatch(setIsLoading(false));

                if (json.status !== 'success') {
                    throw 'error from server';
                } else if (json.data.length < 1) {
                    dispatch(setNoMoreMusics(true));

                    if (init === 0) {
                        showInfo('Não foram encontradas músicas para esse filtro');
                    } else {
                        showInfo('Não foram encontradas mais músicas');
                    }
                } else {
                    if (json.data.length < num) {
                        // we got less musics than we requested, so there are no more musics on the server
                        dispatch(setNoMoreMusics(true));
                    } else {
                        // reset the flag, just in case
                        dispatch(setNoMoreMusics(false));
                    }

                    if (init === 0) {
                        dispatch(setMusicData(json.data));
                    } else {
                        dispatch(addMusicData(json.data));
                    }
                }
            })
            .catch((err) => {
                dispatch(setIsLoading(false));

                // eslint-disable-next-line no-console
                console.error(err);
            });
    }

    return false;
};

export const getFilteredMusicDataIfNeeded = (num, init, options) => (dispatch, getState) => {
    // if init is 0 reset the musics array, otherwise append the result

    const filteredMusicData = getState().musics.musicsPage.filteredMusics;
    const lastFilterQuery = getState().musics.musicsPage.lastFilterQuery;
    const filterQuery = queryString.stringify(options);

    if (filteredMusicData.length < num + init || filterQuery !== lastFilterQuery) {
        dispatch(setIsLoading(true));

        if (lastFilterQuery !== filterQuery) {
            dispatch(setFilteredMusicData([]));
        }

        const query = `api/v1/getFilteredMusicData/${num}/${init}?${filterQuery}`;

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status !== 'success') {
                    throw 'error from server';
                } else if (json.data.length < 1) {
                    dispatch(setNoMoreFilteredMusics(true));

                    if (init === 0) {
                        showInfo('Não foram encontradas músicas para esse filtro');
                    } else {
                        showInfo('Não foram encontradas mais músicas');
                    }
                } else {
                    if (json.data.length < num) {
                        // we got less musics than we requested, so there are no more musics for this filter
                        dispatch(setNoMoreFilteredMusics(true));
                    } else {
                        // reset the flag, just in case
                        dispatch(setNoMoreFilteredMusics(false));
                    }

                    dispatch(setLastFilterQuery(filterQuery));

                    if (init === 0) {
                        dispatch(setFilteredMusicData(json.data));
                    } else {
                        dispatch(addFilteredMusicData(json.data));
                    }
                }
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);
            })
            .finally(() => {
                dispatch(setIsLoading(false));
            });
    }

    // The following setIsLoading is needed because when typing on musicsPage search field isLoading is set to true to achieve a visual spinner fx
    // but that set happens also when ssr the page with some name filter applied, which don't trigger the above code meaning that isLoading will never
    // be set to false.
    return dispatch(setIsLoading(false));
};


// This is for the shortcodes
// This is no "real" action!
// TODO: maybe make this use the trackID to be easier to use on the admin?!
export const getMusicData = (artistSlug, musicSlug) => (dispatch) => {
    const query = `api/v1/getSingleMusicData/${artistSlug}/${musicSlug}`;

    return Api.progressGet(dispatch, query)
        .then((json) => {
            if (json.status === 'success') {
                return Promise.resolve(json.data);
            }

            if (json.status === 404) {
                throw 'music not found';
            }

            throw `error from server: ${json.message}`;
        });
};
